import AbstractButton from './AbstractButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import React from 'react';
import { VolumeOffIcon, VolumeOnIcon } from 'assets/images';
import { translate } from 'store/modules/base/i18n';
import { connect } from 'store/modules/base/redux';

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class SpeakerButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.silence';
  label = 'toolbar.speakerOn';
  toggledLabel = 'toolbar.speakerOff';
  type = 'gray';
  icon = VolumeOnIcon;
  toggledIcon = VolumeOffIcon;

  /**
   * Initializes a new HangupButton instance.
   *
   * @param {Props} props - The read-only properties with which the new
   * instance is to be initialized.
   */
  constructor(props) {
    super(props);
  }

  /**
   * Handles clicking / pressing the button, and disconnects the conference.
   *
   * @protected
   * @returns {void}
   */
  _handleClick() {
    //
  }

  /**
   * Indicates whether this button is in toggled state or not.
   *
   * @override
   * @protected
   * @returns {boolean}
   */
  _isToggled() {
    return this.props._isVideoOnly;
  }

  /**
   * Indicates if video is currently disabled or not.
   *
   * @override
   * @protected
   * @returns {boolean}
   */
  _isDisabled() {
    return true;
  }
}

/**
 * Maps (parts of) the Redux state to the associated {@code HangupButton}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The own props of the component.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
  return {
    _isVideoOnly: state['features/settings'].videoOnly,
    _userIdleMode: state['features/settings'].userIdleMode
  };
}
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(SpeakerButton)))
);
